/*
 * ADJUSTMENT-METHOD-FORMATTER.JS - Formatter for adjustment method labels
 *
 * SUMMARY:
 * Utility to format backend adjustment method codes into human-friendly labels
 * used across the UI (e.g., audit history tables and dropdowns).
 */

/**
 * Returns a human-friendly label for an adjustment method code.
 * Accepted codes: 'FINAL_AMOUNT', 'EXACT_AMOUNT', 'MARGIN_PERCENT', 'RESTORE'.
 * Falls back to the original value when unknown.
 *
 * @param {string} value - The adjustment method code from the backend
 * @returns {string} Human-readable label
 *
 * @example
 * formatAdjustmentMethod('FINAL_AMOUNT'); // "Rounding Method"
 * formatAdjustmentMethod('EXACT_AMOUNT'); // "Target Amount Method"
 * formatAdjustmentMethod('MARGIN_PERCENT'); // "Margin Percent Method"
 * formatAdjustmentMethod('RESTORE'); // "Reset to Original"
 */
export function formatAdjustmentMethod(value) {
    if (!value) return '';
    const code = String(value).toUpperCase();
    switch (code) {
        case 'FINAL_AMOUNT':
            return 'Rounding Method';
        case 'EXACT_AMOUNT':
            return 'Target Amount Method';
        case 'MARGIN_PERCENT':
            return 'Margin Percent Method';
        case 'RESTORE':
            return 'Reset to Original';
        default:
            return value;
    }
}


